import moment from 'moment';

// import React from 'react';
const stripHTML = (html) => {
  if (!html) return '';
  return html
    .replace(/<[^>]*>?/gm, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
};

export const columnDefs = (props = {}) => [
  {
    headerName: 'Student Email',
    field: 'studentEmail',
    resizable: true,
    width: 200,
    tooltipField: 'studentEmail',
    valueGetter: (params) =>
      params?.data?.email ?? params?.data?.User?.email ?? 'N/A',
    tooltipValueGetter: (params) =>
      `Email: ${params?.data?.email ?? params?.data?.User?.email} ` ?? 'N/A',
  },
  {
    headerName: 'Plan',
    field: 'Plan',
    resizable: true,
    width: 95,
    tooltipField: 'Plan',
    valueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.planType ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.planType ?? 'N/A',
  },
  {
    headerName: 'Course',
    field: 'Course',
    resizable: true,
    width: 130,
    tooltipField: 'Course',
    valueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.courseType ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.User?.UserSubscriptions?.[0]?.courseType ?? 'N/A',
  },
  {
    headerName: 'Attempt',
    field: 'attempt',
    resizable: true,
    width: 120,
    tooltipField: 'attempt',
    valueGetter: (params) => params?.data?.attempt ?? 'N/A',
    tooltipValueGetter: (params) => params?.data?.attempt ?? 'N/A',
  },
  {
    headerName: 'Progress',
    field: 'Progress',
    resizable: true,
    width: 120,
    tooltipField: 'attempt',
    valueGetter: (params) => params?.data?.progress ?? 'N/A',
    tooltipValueGetter: (params) => params?.data?.progress ?? 'N/A',
  },
  {
    headerName: 'Attempt Date',
    field: 'attemptDate',
    resizable: true,
    width: 190,
    tooltipField: 'attemptDate',
    valueGetter: (params) =>
      params?.data?.started_at
        ? moment(params.data.started_at).format('DD MMM YYYY, hh:mm A')
        : 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.started_at
        ? moment(params.data.started_at).format('DD MMM YYYY, hh:mm A')
        : 'N/A',
  },
  {
    headerName: 'Score',
    field: 'score',
    resizable: true,
    width: 110,
    tooltipField: 'score',
    valueGetter: (params) => params?.data?.total_score ?? 'N/A',
    tooltipValueGetter: (params) => params?.data?.total_score ?? 'N/A',
  },
  {
    headerName: 'Out of',
    field: 'outOf',
    resizable: true,
    width: 110,
    tooltipField: 'outOf',
    valueGetter: (params) => params?.data?.maxscore ?? 'N/A',
    tooltipValueGetter: (params) => params?.data?.maxscore ?? 'N/A',
  },
  {
    headerName: 'Percentage',
    field: 'percentage',
    resizable: true,
    width: 130,
    tooltipField: 'percentage',
    valueGetter: (params) => params?.data?.verdict?.percentage ?? 'N/A',
    tooltipValueGetter: (params) => params?.data?.verdict?.percentage ?? 'N/A',
  },
  {
    headerName: 'Language Proficiency',
    field: 'languageProficiency',
    resizable: true,
    width: 180,
    tooltipField: 'languageProficiency',
    valueGetter: (params) =>
      params?.data?.abCatEvaluation?.languageProficiency ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.abCatEvaluation?.languageProficiency ?? 'N/A',
  },
  {
    headerName: 'Session Link',
    field: 'public_access_url',
    resizable: true,
    width: 140,
    tooltipField: 'public_access_url',
    cellRendererFramework: ({ value }) =>
      value ? (
        <a
          href={value}
          target='_blank'
          rel='noopener noreferrer'
          style={{ color: '#2563eb', textDecoration: 'underline' }}
        >
          Open Link
        </a>
      ) : (
        'N/A'
      ),
  },
  {
    headerName: 'Technical Fluency Audited',
    field: 'technicalFluencyAudited',
    resizable: true,
    width: 200,
    tooltipField: 'technicalFluencyAudited',
    valueGetter: (params) =>
      params?.data?.abCatEvaluation?.technicalFluencyAudited ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.abCatEvaluation?.technicalFluencyAudited ?? 'N/A',
  },
  {
    headerName: 'Communication Fluency Audited',
    field: 'commFluencyAudited',
    resizable: true,
    width: 140,
    tooltipField: 'commFluencyAudited',
    valueGetter: (params) =>
      params?.data?.abCatEvaluation?.commFluencyAudited ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.abCatEvaluation?.commFluencyAudited ?? 'N/A',
  },
  {
    headerName: 'Found Copying',
    field: 'foundCopying',
    resizable: true,
    width: 140,
    tooltipField: 'foundCopying',
    valueGetter: (params) =>
      params?.data?.abCatEvaluation?.foundCopying ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.abCatEvaluation?.foundCopying ?? 'N/A',
  },
  {
    headerName: 'Shortlisted',
    field: 'shortlisted',
    resizable: true,
    width: 130,
    tooltipField: 'shortlisted',
    valueGetter: (params) =>
      params?.data?.abCatEvaluation?.shortList ? 'Yes' : 'No' ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.abCatEvaluation?.shortList ?? 'N/A',
  },
  {
    headerName: 'Decision',
    field: 'Decision',
    resizable: true,
    width: 130,
    tooltipField: 'Decision',
    valueGetter: (params) => params?.data?.abCatEvaluation?.status ?? 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.abCatEvaluation?.status ?? 'N/A',
  },
  {
    headerName: 'AlmaX Cohort',
    field: 'almaXCohort',
    resizable: true,
    width: 150,
    tooltipField: 'almaXCohort',
    valueGetter: (params) =>
      params?.data?.abCatEvaluation?.data?.almaXCohort
        ? params?.data?.abCatEvaluation?.data?.almaXCohort
        : 'N/A',
    tooltipValueGetter: (params) =>
      params?.data?.abCatEvaluation?.data?.almaXCohort ?? 'N/A',
  },

  {
    headerName: 'Internal Remarks',
    field: 'internalRemarks',
    resizable: true,
    width: 180,
    tooltipField: 'internalRemarks',
    valueGetter: (params) => {
      const notes = params?.data?.abCatEvaluation?.data?.interviewNotes;
      if (Array.isArray(notes)) {
        return notes.map((item) => item.remark).join('; ');
      }
      return 'N/A';
    },
    tooltipValueGetter: (params) => {
      const notes = params?.data?.abCatEvaluation?.data?.interviewNotes;
      if (Array.isArray(notes)) {
        return notes.map((item) => item.remark).join(', ');
      }
      return 'N/A';
    },
  },
  {
    headerName: 'Rejection Reasons (external)',
    field: 'rejectionReasons',
    resizable: true,
    width: 220,
    tooltipField: 'rejectionReasons',
    valueGetter: (params) => {
      const raw = params?.data?.abCatEvaluation?.rejectReason ?? 'N/A';
      return stripHTML(raw);
    },
    tooltipValueGetter: (params) => {
      const raw = params?.data?.abCatEvaluation?.rejectReason ?? 'N/A';
      return stripHTML(raw);
    },
  },
  {
    headerName: 'Email Sent Status',
    field: 'emailSentStatus',
    resizable: true,
    width: 190,
    tooltipField: 'emailSentStatus',
    valueGetter: (params) => {
      const emailSent = params?.data?.abCatEvaluation?.emailSent;
      const history = params?.data?.abCatEvaluation?.data?.history;

      if (emailSent === true && Array.isArray(history) && history.length > 0) {
        return moment(history[0]?.timestamp).format('DD MMM YYYY, hh:mm A');
      } else {
        return 'N/A';
      }
    },
  },
  // Uncomment and adjust if you want to use these columns:
  // {
  //   headerName: 'AB-CAT Ver',
  //   field: 'abcatVer',
  //   resizable: true,
  //   width: 130,
  //   tooltipField: 'abcatVer',
  //   valueGetter: (params) => params?.data?.abCatEvaluation?.abcatVer ?? 'N/A',
  //   tooltipValueGetter: (params) => params?.data?.abCatEvaluation?.abcatVer ?? 'N/A',
  // },
  // {
  //   headerName: 'Progress During AB-CAT 1st Attempt',
  //   field: 'progressDuringAbcatFirstAttempt',
  //   resizable: true,
  //   width: 240,
  //   tooltipField: 'progressDuringAbcatFirstAttempt',
  //   valueGetter: (params) => params?.data?.abCatEvaluation?.progressDuringAbcatFirstAttempt ?? 'N/A',
  //   tooltipValueGetter: (params) => params?.data?.abCatEvaluation?.progressDuringAbcatFirstAttempt ?? 'N/A',
  // },
  {
    headerName: 'Actions',
    field: 'actions',
    width: 280,
    pinned: 'right',
    resizable: true,
    cellRenderer: (params) => {
      const evaluation = params?.data?.abCatEvaluation;
      const courseType = params?.data?.User?.UserSubscriptions?.[0]?.courseType;
      const isEmailSent = params?.data?.abCatEvaluation?.emailSent;
      // const userId = params?.data?.id;
      console.log(params?.data, 'params in actions cellRenderer');

      // Default color
      let buttonColor = '#CCCCCC';

      console.log(evaluation, courseType, 'asdjk');

      if (evaluation) {
        if (
          evaluation.status === 'approved' ||
          evaluation.status === 'shortlisted'
        ) {
          buttonColor = '#339933'; // green
        } else if (evaluation.status === 'rejected') {
          buttonColor = '#FF9999'; // red
        } else if (evaluation.shortList != null) {
          // Shortlisted color depends on course
          if (courseType === 'data-science') {
            buttonColor = '#CC99FF'; // lavender for Data Science
          } else if (courseType === 'web3') {
            buttonColor = '#FFCC99'; // orange for Web Development
          }
        }
      }

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button
            style={{
              background: buttonColor,
              color: '#ffff',
              border: 'none',
              borderRadius: 4,
              padding: '4px 10px',
              cursor: 'pointer',
              fontWeight: 'noraml',
              width: '120px',
            }}
            onClick={() => props.onReject && props.onReject(params.data)}
          >
            {evaluation ? 'Update AB-CAT' : 'Evaluate AB-CAT'}
          </button>
          <button
            style={{
              background: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: 4,
              padding: '4px 10px',
              cursor: 'pointer',
              width: '100px',
            }}
            onClick={() => props.onSendEmail && props.onSendEmail(params.data)}
          >
            {isEmailSent ? 'Resend Email' : 'Send Email'}
          </button>
        </div>
      );
    },
  },
];
